import { render, staticRenderFns } from "./NetworkNotification.vue?vue&type=template&id=72d90eee&scoped=true&"
import script from "./NetworkNotification.vue?vue&type=script&lang=js&"
export * from "./NetworkNotification.vue?vue&type=script&lang=js&"
import style0 from "./NetworkNotification.vue?vue&type=style&index=0&id=72d90eee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d90eee",
  null
  
)

export default component.exports